module.exports = __webpack_public_path__ + "static/media/calendar.b46a70b3.svg";